import "./editUser.css"
import { handleUpdateUser , handleGetUser} from "../../requests/userRequests"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useGlobalContext } from "../../context"
import useAuthUser from "react-auth-kit/hooks/useAuthUser"


function EditUser() {
    const User = useAuthUser()
    const days = ["روز", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"]
    const month = ["ماه", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
    const year = ["سال", "1383", "1382", "1381", "1380", "1379", "1378", "1377", "1376", "1375", "1374", "1373", "1372", "1371", "1370", "1369", "1368", "1367", "1366",]
    const {handleErr} = useGlobalContext()
    const [user , setUser] = useState({
        name : "",
        family : "",
        meliCode : "",
        gender : "",
        birthday : {day : "" , month : "" , year : ""},
        howMeet : "",
        SOM : "",
    })
    useEffect(async() => {
        try{
            const res = await handleGetUser(User._id)
            setUser(res)
        }catch(err){
            console.log(err)
        }
    } , [])
    const handleUpdate = async () => {
        try{
            const res = await handleUpdateUser(User._id , user)
            handleErr(res.type , res.massage)
        }catch(err){
            console.log(err)
        }
    }
    return (
        <div className="edit-user">
            <div className="edit-user-container">
                <h2 className="user-info-title">اطلاعات فردی</h2>
                <div className="inputs-container">
                    <div className="form__group field">
                        <input onChange={(e) => setUser({...user , name : e.target.value})} value={user.name} type="input" className="form__field" placeholder="Name" required="" />
                        <label className="form__label">نام</label>
                    </div>
                    <div className="form__group field">
                        <input onChange={(e) => setUser({...user , family : e.target.value})} value={user.family} type="input" className="form__field" placeholder="Name" required="" />
                        <label className="form__label">نام خانوادگی</label>
                    </div>
                    <div className="form__group field">
                        <input onChange={(e) => setUser({...user , meliCode : e.target.value})} value={user.meliCode} type="input" className="form__field" placeholder="Name" required="" />
                        <label className="form__label">کد ملی</label>
                    </div>
                    <div className="form__group field">
                        <input type="input" className="form__field phoneNumber" placeholder="Name" required="" value={user.phoneNumber} />
                        <label className="form__label">تلفن همراه</label>
                        <Link style={{textDecoration : "underline"}} to={"/"}>تغییر شماره موبایل</Link>
                    </div>
                </div>
                <div className="select-holder">
                    <div className="gender">
                        <span>جنسیت:</span>
                        <select onChange={(e) => setUser({...user , gender : e.target.value})} value={user.gender} name="gender" id="gender-select">
                            <option value="">جنسیت</option>
                            <option value="mail">مرد</option>
                            <option value="femail">زن</option>
                        </select>
                    </div>
                    <div className="birthday">
                        <span>تولد:</span>
                        <select onChange={(e) => setUser({...user , birthday : {...user.birthday , day : e.target.value}})} value={user.birthday.day} name="day" id="birthday-select">
                            {days.map((item, i) => {
                                return (
                                    <option key={i} value={item}>{item}</option>
                                )
                            })}
                        </select>
                        <select onChange={(e) => setUser({...user , birthday : {...user.birthday , month : e.target.value}})} value={user.birthday.month} name="month" id="birthday-select">
                            {month.map((item, i) => {
                                return (
                                    <option key={i} value={item}>{item}</option>
                                )
                            })}
                        </select>
                        <select onChange={(e) => setUser({...user , birthday : {...user.birthday , year : e.target.value}})} value={user.birthday.year} name="year" id="birthday-select">
                            {year.map((item, i) => {
                                return (
                                    <option key={i} value={item}>{item}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="meet">
                        <span>نحوهآشنایی:</span>
                        <select  onChange={(e) => setUser({...user , howMeet : e.target.value})} value={user.howMeet} name="meet" id="meet-select">
                            <option value="">نحوه آشنایی</option>
                            <option value="سایت">سایت</option>
                            <option value="دوستان">دوستان</option>
                            <option value="تبلیغات">تبلیغات</option>
                            <option value="هیچکدام">هیچکدام</option>
                        </select>
                    </div>
                    <div className="single">
                        <span>وضعیت تاهل:</span>
                        <select  onChange={(e) => setUser({...user , SOM : e.target.value})} value={user.SOM} name="single" id="single-select">
                            <option value="">وضعیت تاهل</option>
                            <option value="مجرد">مجرد</option>
                            <option value="متاهل">متاهل</option>
                        </select>
                    </div>
                </div>
                <button className="sub-user-info" onClick={() => handleUpdate()}>
                    ثبت اطلاعات
                </button>
            </div>
        </div>
    )
}
export default EditUser;